import { useEffect, useState } from 'react';
import { differenceInMonths } from 'date-fns';
import { Alert, AlertTitle } from '@mui/material';

export interface TrendSummaryBannerProps {
    minDate: Date;
}

export const TrendSummaryBanner = ({ minDate }: TrendSummaryBannerProps) => {
    const [monthDiff, setMonthDiff] = useState<number>(0);

    useEffect(() => {
        setMonthDiff(differenceInMonths(new Date(), minDate));
    }, [minDate]);

    return (
        <Alert severity="info" data-testid="TrendSummaryBanner">
            <AlertTitle>
                {`Showing trends based on deliveries from the last ${
                    monthDiff > 1 ? monthDiff : ''
                } ${
                    monthDiff === 1 ? 'month' : 'months'
                } for which data is available.`}
            </AlertTitle>
        </Alert>
    );
};
